// 📁 src/components/FeedbackBubble.jsx (VERSIÓN FINAL Y CONSISTENTE)
import React from 'react';
import clsx from 'clsx';
import { marked } from 'marked';
import * as LucideIcons from "lucide-react";

const Icon = ({ name, size = 16, className = "" }) => {
    const LucideIcon = LucideIcons[name];
    return LucideIcon ? <LucideIcon size={size} className={clsx("stroke-[1.5]", className)} /> : null;
};

const FeedbackBubble = ({ content, opciones, onOptionClick, isProcessing }) => {
    if (!content) return null; // Guardia de seguridad
    let parsedContent = (typeof content === 'string') ? JSON.parse(content || '{}') : (content || {});
    const { titulo, texto, respuestaCorrecta } = parsedContent;
    const esCorrecta = titulo?.toLowerCase().includes('bien') || titulo?.toLowerCase().includes('excelente') || titulo?.toLowerCase().includes('buena') || titulo?.toLowerCase().includes('gran');;

    return (
        <div className={clsx('p-4 rounded-xl shadow-md self-start rounded-tl-none mb-4 w-full text-white animate-fadeIn', esCorrecta ? 'bg-gradient-to-br from-green-600 to-green-800' : 'bg-gradient-to-br from-red-600 to-red-800')}>
            <div className="flex flex-col space-y-3 w-full">
                <h3 className={clsx('text-lg font-bold flex items-center', esCorrecta ? 'text-green-200' : 'text-red-200')}>
                    {esCorrecta ? <Icon name="CheckCircle" /> : <Icon name="XCircle" />} 
                    <span className="ml-2">{titulo}</span>
                </h3>
                {texto && <div className="text-sm text-gray-100" dangerouslySetInnerHTML={{ __html: marked.parse(texto) }} />}
                {respuestaCorrecta && (
                    <div className="border-t border-white/20 pt-3 mt-2">
                         <p className="text-xs text-gray-300 font-semibold">Respuesta Correcta:</p>
                         <p className="text-sm text-white font-medium">{respuestaCorrecta}</p>
                    </div>
                )}
                <div className="flex items-center justify-center gap-4 w-full pt-3 mt-2">
                    {opciones && opciones.map((opcion, index) => (
                        <button
                            key={index}
                            onClick={() => onOptionClick(opcion)}
                            disabled={isProcessing}
                            className="flex items-center justify-center px-4 py-2 bg-white/90 text-gray-800 rounded-full hover:bg-white transition-colors duration-200 shadow-lg disabled:opacity-50"
                        >
                            <Icon name={opcion.icono || 'HelpCircle'} size={16} className="mr-2" />
                            <span className="font-semibold">{opcion.etiqueta}</span>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FeedbackBubble;